module.exports = __webpack_public_path__ + "static/img/image_set_juicies.297a3b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/shop/image_set_juicies.jpg
// module id = E+G1
// module chunks = 1